import CardPrioridad from './CardPrioridad';

export default CardPrioridad;